module.exports = {
  NODE_ENV: '"production"'
}



// WEBPACK FOOTER //
// ./config/prod.env.js